import React, { useState, useRef, useEffect } from 'react';
import './ChatBot.css';
import axios from 'axios';
import BASE_URL from '../config';

const ChatBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { from: 'bot', text: 'Hello! How can I help you today?' }
  ]);
  const [input, setInput] = useState('');
  const [step, setStep] = useState(null);
  const [studentInfo, setStudentInfo] = useState({});
  const chatEndRef = useRef(null);

  const scrollToBottom = () => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSend = async () => {
    if (input.trim() === '') return;

    setMessages(prev => [...prev, { from: 'user', text: input }]);

    if (step === 'askName') {
      const updatedInfo = { ...studentInfo, studentname: input };
      setStudentInfo(updatedInfo);
      setMessages(prev => [...prev, { from: 'bot', text: 'Please enter your mobile number:' }]);
      setStep('askMobile');
    } else if (step === 'askMobile') {
      const updatedInfo = { ...studentInfo, mobilenumber: input };
      setStudentInfo(updatedInfo);
      setMessages(prev => [...prev, { from: 'bot', text: 'Fetching fee details...' }]);
      setInput('');
      setStep(null);
      fetchFeeDetails(updatedInfo);
      return;
    } else {
      setMessages(prev => [...prev, { from: 'bot', text: 'Please click the "Fees Details" button to continue.' }]);
    }

    setInput('');
  };
  const clearChat = () => {
    setMessages([{ from: 'bot', text: 'Hello! How can I help you today?' }]);
    setInput('');
    setStep(null);
    setStudentInfo({});
  };

  const fetchFeeDetails = async (info) => {
    try {
      const res = await axios.post(`${BASE_URL}/get-feesdetail`, info);
      const { studentName, studentId, totalFees, paidFees, balance } = res.data;

      const cardMessage = `
📚 *Fee Details*

👤 Name: ${studentName}
🆔 ID: ${studentId}
💰 Total Fees: ₹${totalFees}
✅ Paid: ₹${paidFees}
❗ Balance: ₹${balance}
      `;

      setMessages(prev => [...prev, { from: 'bot', text: cardMessage }]);
    } catch (error) {
      console.error('Error fetching fee details:', error);
      setMessages(prev => [...prev, { from: 'bot', text: 'Sorry, something went wrong while fetching fee details. Please try again later.' }]);
    }
  };

  const startFeeInquiry = () => {
    setMessages(prev => [...prev, { from: 'bot', text: 'Please enter your name:' }]);
    setStep('askName');
  };

  return (
    <div className="chatbot-container">
      <button className="chatbot-toggle" onClick={() => setIsOpen(!isOpen)}>
        💬 Chat
      </button>

      {isOpen && (
        <div className="chatbot-box">
          <div className="chatbot-header">💬 ChatBot</div>

          <div className="chatbot-messages">
            {messages.map((msg, idx) => (
              <div key={idx} className={`chatbot-message ${msg.from}`}>
                {msg.text.split('\n').map((line, i) => (
                  <div key={i}>{line}</div>
                ))}
              </div>
            ))}
            <div ref={chatEndRef} />
          </div>

          <div className="chatbot-input-area">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSend()}
              placeholder="Type your message..."
            />
            <button onClick={handleSend}>Send</button>
          </div>

          <div className="chatbot-options">
            <button onClick={startFeeInquiry}>🎓 Fees Details</button>
            <button onClick={clearChat}>🎓 clear</button>

          </div>
         </div>
      )}
    </div>
  );
};

export default ChatBot
